module.exports = __webpack_public_path__ + "static/media/ImperialLogo.59afba84.jpg";